import React from 'react'
import styles from './ErrorLabel.module.scss'
import {cx} from '../../utils'
import {useWt} from '@npm-questionpro/wick-ui-lib'
import {GLOBAL} from '../../Translation/English/global'

interface IErrorLabelProps {
  title?: string
  /** Optional scoped class from a consumer (e.g. positioning) — explicit contract
   * replacing the former `.error-label` reach-in. */
  className?: string
}

export const ErrorLabel: React.FC<IErrorLabelProps> = ({title, className}) => {
  const wt = useWt()

  return (
    <label className={cx(styles.errorLabel, className)}>
      {title} {wt(GLOBAL.required)}
    </label>
  )
}
